/* eslint-disable camelcase */
/**
 * Current library was added specifically to lazy load videos,
 * but can be used for any media content: images, animated SVGs, videos and iframes.
 *
 * @see https://github.com/verlok/vanilla-lazyload
 * @see https://web.dev/lazy-loading-video/
 */
import LazyLoad from 'vanilla-lazyload';
import { EventBus } from '@v4/common/utils/event-bus';

const lazyLoadOptions = {
    elements_selector: '.lazy',
    to_webp: true,
    callback_loaded: (element) => {
        EventBus.$emit(`${element.id}:loaded`);
    },
};

const createLazyLoadInstance = () => new LazyLoad(lazyLoadOptions);

export default () => {
    document.addEventListener('DOMContentLoaded', createLazyLoadInstance);
};
